import './App.css';
import LandingPage from './components/LandingPage';
import {Routes,Route} from "react-router-dom";
import VideoPage from './components/VideoPage';
import {useState,useEffect} from 'react';
import axios from 'axios';

function App() {

const [videoList, setVideolist] = useState([]);
const [loading,setLoading]=useState(false);
const [videoListAfter,setVideoListAfter]=useState([]);
const mockServerAddress="https://734e965e-9911-41b2-9cfe-b7eb86953ee8.mock.pstmn.io";
const [handleGenreArr,setHandleGenreArr]=useState([]);

const performApiCall = async ()=>
{
  setLoading(true);
  
    try{
    const response = await axios.get(`${mockServerAddress}/v1/videos`);
        setVideolist(response.data.videos)
        setVideoListAfter(response.data.videos)
    } catch (e) {
      console.log(e)
    } 
    setLoading(false); 
}

const handleSearch= async (event)=>
{
  const typedValue=event;
  setLoading(true);
  try{
    const response = await axios.get(`${mockServerAddress}/v1/videos?title=${typedValue}`)
    if(typedValue.length!==0)
    {
      setVideolist(response.data.videos)
    }
    else
    {
      setVideolist(videoListAfter)
    }
  }catch (e)
  {
    console.log(e)
  }
  setLoading(false);

}

const handleGenre=async(item)=>
{
  setLoading(true);
 let set= new Set(handleGenreArr);
if(set.has(item))
{
    set.delete(item)
}else
{
    set.add(item)
}
setHandleGenreArr(Array.from(set));
  let str=encodeURI(handleGenreArr);
  console.log(str)
  if(item==='All Genre')
  {
      setVideolist(videoListAfter)
  }
  else
  {
  try{
    const response = await axios.get(`${mockServerAddress}/v1/videos?genres=${str}`)
      setVideolist(response.data.videos)
   
  }catch (e)
  {
    console.log(e)
  }
}
  setLoading(false);

}


const handleAge=async(item)=>
{
  setLoading(true);
 let str=encodeURI(item);
  console.log(str)
  if(item==='Any Age Group')
  {
      setVideolist(videoListAfter)
  }
  else
  {
  try{
    const response = await axios.get(`${mockServerAddress}/v1/videos?contentRating=${str}`)
      setVideolist(response.data.videos)
   
  }catch (e)
  {
    console.log(e)
  }
}
  setLoading(false);

}

const handleDropDown=async(item)=>
{
  setLoading(true);
 let str=encodeURI(item.target.value);
  console.log(str)
  try{
    const response = await axios.get(`${mockServerAddress}/v1/videos?sortBy=${str}`)
      setVideolist(response.data.videos)
   
  }catch (e)
  {
    console.log(e)
  }

  setLoading(false);

}




useEffect(() => {
    // code to run after render goes here
    performApiCall();
  },[]);

  return (
    <div className="App">
      <Routes>
       <Route path='/' element={<LandingPage videoList={videoList}  loading={loading} handleSearch={handleSearch} handleGenre={handleGenre} handleAge={handleAge} handleDropDown={handleDropDown}/>} ></Route>
       <Route path='video/:id' element={<VideoPage videoList={videoList}/>}></Route>
     </Routes>
   
    </div>
  );
}

export default App;
